/**
 * PerformAI API
 * PerformAI API documentation
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Action } from './action';
import { User } from './user';


export interface UserUploadHistory {
    action?: Action;
    clientSideMetadata?: string;
    commentImage?: string;
    commentText?: string;
    comparasionDate?: string;
    comparasionResult?: string;
    id?: string;
    printFiles?: { [key: string]: string; };
    renderDate?: string;
    renderedImages?: Array<string>;
    renderedObjects?: Array<string>;
    renderedVideos?: Array<string>;
    title?: string;
    trimmedVideo?: string;
    uploadDate?: string;
    uploadedVideo: string;
    user?: User;
}

